<!--
 - Author : wanghongling.
 - Date   : 2020/12/23.
 - File   : contractor.名厨亮灶承包商公示
 -->

<template>
  <layer title="运营商公示" titleClass="01" width="326px" padding="15px 20px">
    <div class="contractor-wrap">
      <div class="contractor-wrap-item" v-for="(item, index) in list" :key="index">
        <p>{{item.contractorName}}</p>
      </div>
      <div class="no-the-data" v-if="list && list.length===0">
        <div>
          <i class="iconfont icon-suoyourenyuan dzi"></i>
          <p>暂无运营商</p>
        </div>
      </div>
    </div>
  </layer>
</template>

<script>
  export default {
    name: 'contractor',
    data () {
      return {
        name: 'overdueTemperature',
        list: [],
        page: 1,
        pageSize: 6
      }
    },
    watch: {
      selectDeptId: {
        handler(cur) {
          this.departmentId = cur
          this.getContractorList()
        },
        deep: true
      }
    },
    props: ['selectDeptId'],
    mounted() {
      if(this.departmentId) {
        this.getContractorList()
      }
      this.contractorWsMsg()
    },
    methods: {
      /**
       * @author wanghongling
       * @createTime 2020/12/24
       * @description websocket监听数据
       */
      contractorWsMsg () {
        window.getContractorInfo = e => {
          console.log(e, 'websocket监听数据')
          this.getContractorList()
        }
      },
      /**
       * @Description:获取名厨亮灶承包商列表
       * @author wanghongling
       * @createDate 2020/12/24
       */
      getContractorList() {
        let params = {
          departmentId: this.departmentId,
          page: this.page,
          pageSize: this.pageSize
        }
        this.$request.constramanageListGet(params).then(res => {
          console.log('获取名厨亮灶承包商列表', res)
          if(!this.$utils.isEmptyObject(res)) {
            this.list = res.list
          }
        }).catch(e => {
          console.error(e)
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .contractor-wrap{
    margin-top: -2px;
    min-height: 195px;
    .no-the-data{
      height: 210px;
    }
    &-item{
      font-size: 15px;
      color: #00fffc;
      margin-top: 15px;
      cursor: pointer;
      p{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      &:hover{
        opacity: 0.8;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mingChu/contractor.vue